import LearningListContainer from "../../../../Components/Miscellaneous/Learning/LearningList/LearningListContainer";

const LearningList = () => {
  return <LearningListContainer />;
};

export default LearningList;
